<template>
  <div class="pages-account">
    <div class="top-line">
      <div class="small-button" @click="toBack()">返回</div>
      <span class="title">
        {{ isAdult ? '待审核注册申请' : '帐号管理' }}
      </span>
    </div>
    <div class="content">
        <div class="create-btn">
            <el-input v-if="role == 1 && !isAdult" placeholder="请输入手机号" style="position: absolute; top:20px; left: 10px; width: 130px;" v-model="phone" maxlength="11"></el-input>
            <el-select v-if="role == 1 && !isAdult" v-model="sms_status"  style="position: absolute; top:20px; left: 150px;width: 100px">
              <el-option label="全部" value="-2"></el-option>
              <el-option label="发送失败" value="-1"></el-option>
              <el-option label="发送中" value="0"></el-option>
              <el-option label="发送成功" value="1"></el-option>
            </el-select>
            <el-button v-if="role == 1 && !isAdult" @click="search()" type="primary" style="position: absolute; top:20px; left: 260px">查询</el-button>
            <el-button v-if="role == 1 && !isAdult" @click="toExport()" type="primary" style="position: absolute; top:20px; left: 340px">导出帐号信息</el-button>
            <el-button v-if="role == 1 && !isAdult" type="text" style="margin-right: 10px" @click="downloadTemplate">下载批量模板</el-button>
            <el-button v-if="role == 1 && !isAdult" type="primary" style="position:relative;margin-right: 10px">批量新增
              <input class="hide-button" type="file" @change="onBatchAddAccount" />
            </el-button>
            <el-button v-if="role == 1 && !isAdult" @click="toAddSchool()" type="primary" style="margin-right: 20px">新增</el-button>
            <div v-if="!isAdult" class="audit" style="margin-right: 0px">
              <div v-if="auditNum > 0" class="audit-num">{{ auditNum }}</div>
              <el-button  @click="toAdult()" type="primary">待审核</el-button>
            </div>
            <!-- <el-button v-if="role == 3 && !isAdult" @click="toCreate()" type="primary">{{ role == 3 ? '创建老师帐号' : '创建校级帐号' }} </el-button> -->
        </div>
      <el-table
        :data="data"
        style="width: 100%; margin-bottom: 10px"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">{{
            scope.$index + 1 + (pageNum - 1) * 30
          }}</template>
        </el-table-column>
        <el-table-column
          prop="nick_name"
          :label="role==3?'老师姓名':'学校名字'"
          width="width"
          align="center"
        >
            <template slot-scope="scope">
              {{ scope.row.nick_name || scope.row.name }}
            </template>
        </el-table-column>
        <!-- <el-table-column
          v-if="role == 1"
          prop="user_name"
          label="校级帐号"
          width="width"
          align="center"
        >
            <template slot-scope="scope">
              {{ scope.row.user_name || scope.row.name }}
            </template>
        </el-table-column> -->
        <!-- <el-table-column
          v-if="role == 1"
          prop="password"
          label="初始密码"
          width="width"
          align="center"
        >
        <template>
              123456
            </template>
        </el-table-column> -->
        <el-table-column
          prop="user_name"
          label="手机号"
          width="width"
          align="center"
        ></el-table-column>
        </el-table-column>
        <el-table-column
          v-if="role == 1"
          prop="user_name"
          label="地区归属"
          width="width"
          align="center"
        >
            <template slot-scope="scope">
              {{ scope.row.school.province_name }}{{ scope.row.school.city_name }}{{ scope.row.school.area_name }}
            </template>
        </el-table-column>
        <el-table-column
          v-if="role == 1"
          prop="user_name"
          label="短信状态"
          width="width"
          align="center"
        >
            <template slot-scope="scope">
              {{ scope.row.sms_status == '-1' ? '发送失败' : scope.row.sms_status == '0' ? '发送中' : '发送成功' }}
            </template>
        </el-table-column>
        <el-table-column
          v-if="role == 1"
          prop="user_name"
          label="申请书"
          width="width"
          align="center"
        >
            <template slot-scope="scope">
              <!-- <img class="yyzz" :src="scope.row.school.certificate" alt=""> -->
              <el-image
                v-if="scope.row.school.certificate"
                class="yyzz"
                :src="scope.row.school.certificate"
                :preview-src-list="[scope.row.school.certificate]">
              </el-image>
            </template>
        </el-table-column>
        <el-table-column
          v-if="role == 1 || (role == 3 && isAdult)"
          prop="created_at"
          label="注册时间"
          width="width"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="role == 3 && !isAdult"
          prop="created_at"
          label="上传资源文件大小"
          width="width"
          align="center"
        >
          <template slot-scope="scope">
            {{ getFileSize(scope.row.file_size) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <!-- <div v-if="role == 3 && !isAdult" class="small-button" @click="toEdit(scope.row)" style="margin-right: 10px">编辑</div>  -->
              <div v-if="role == 1 && !isAdult" class="small-button" @click="toDetail(scope.row)" style="margin-right: 10px">查看</div> 
              <div v-if="!isAdult && scope.row.status == 1" class="small-button" @click="toBan(scope.row)" style="margin-right: 10px; color: #F56C6C; border: 1px solid #F56C6C">禁用</div>
              <div v-if="!isAdult && scope.row.status == 0" class="small-button" @click="toBan(scope.row)" style="margin-right: 10px">启用</div>
              <div v-if="!isAdult" class="small-button" @click="toDelete(scope.row)" style="color: #808080; border: 1px solid #808080">删除</div>

              <div v-if="isAdult" class="small-button" @click="toVerify(scope.row, 1)" style="margin-right: 10px">通过</div>
              <div v-if="isAdult" class="small-button" @click="toVerify(scope.row, 0)" style="color: #F56C6C; border: 1px solid #F56C6C">拒绝</div>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :page-size="30"
        :total="total"
        class="pagination"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

    <div v-if="showSchoolDetail" class="create-mask">
      <div class="school-detail">
        <div class="school-detail-close" @click="closeSchoolDetail()"></div>
        <div class="school-detail-table">
          <div class="school-detail-line">
            <div class="school-detail-title">学校名称</div>
            <div class="school-detail-content">
              <!-- 南京市浦口区桥林街道兰花中心幼儿园茶棚办学点 -->
              {{ schoolDetail.nick_name }}
            </div>
          </div>
          <div class="school-detail-line">
            <div class="school-detail-title">注册手机号</div>
            <div class="school-detail-content">
              {{ schoolDetail.phone }}
            </div>
          </div>
          <div v-if="schoolDetail.real_name" class="school-detail-line">
            <div class="school-detail-title">联系人姓名</div>
            <div class="school-detail-content">
              {{ schoolDetail.real_name || '-' }}
            </div>
          </div>
          <div v-if="schoolDetail.first_pwd" class="school-detail-line">
            <div class="school-detail-title">初始密码</div>
            <div class="school-detail-content">
              {{ schoolDetail.first_pwd || '-' }}
            </div>
          </div>
        </div>
        <div v-if="schoolDetail.first_pwd" class="school-detail-ms">
          <div class="school-detail-ms-title">已发送短信：</div>
          <div class="school-detail-ms-content">
您申请注册的幼儿园账号已通过审核，登录账号为：{{ schoolDetail.phone }}（手机号），初始密码为：{{ schoolDetail.first_pwd || '******' }}，请前往https://www.yeykcfa.cn/登录使用。（幼儿园综合活动课程方案平台）       
          </div>
          <div class="school-detail-ms-time">短信发送时间：{{updated_at || ''}}</div>
          <div class="school-detail-ms-time">短信发送状态：{{schoolDetail.sms_status == '-1' ? '发送失败' : schoolDetail.sms_status == '0' ? '发送中' : '发送成功'}}</div>
        </div>
        <div class="school-detail-btn" @click="closeSchoolDetail()">确定</div>
      </div>
    </div>


    <div v-if="showCreate && role == 3" class="create-mask">
      <div class="create-content">
        <div class="create-close" @click="closeCreate()"></div>
        <div class="create-line">
            <div class="create-title create-title-teacher">请填写老师手机号：</div>
            <el-input
                v-model="teacherPhone"
                placeholder="输入手机号"
                style="width: 224px"
            ></el-input>
        </div>
        <div class="create-line">
            <div class="create-title create-title-teacher">请填写老师名字：</div>
            <el-input
                v-model="createName"
                placeholder="输入姓名"
                style="width: 224px"
            ></el-input>
        </div>
        <div class="submit" @click="submit()">{{editId ? '确认修改' : '确认添加 '}} </div>
      </div>
    </div>
    <div v-if="showCreate && role == 1" class="create-mask">
        <div class="create-content">
            <div class="create-close" @click="closeCreate()"></div>
            <div class="create-line">
                <div class="create-title">请选择学校地区：</div>
                <el-select
                    v-model="schoolProvince"
                    clearable
                    placeholder="选择省份"
                    style="width: 150px; margin-right: 10px"
                    @change="selectProvince()"
                >
                    <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.province_id"
                    >
                    </el-option>
                </el-select>
                <el-select
                    v-model="schoolCity"
                    clearable
                    placeholder="选择市"
                    style="width: 150px"
                >
                    <el-option
                        v-for="(item, index) in cityList"
                        :key="index"
                        :label="item.name"
                        :value="item.city_id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="create-line">
                <div class="create-title">请填写学校名字：</div>
                <el-input
                    v-model="createName"
                    placeholder="输入内容"
                    style="width: 224px"
                ></el-input>
            </div>
            <div class="submit" @click="submit()">提交</div>
        </div>
    </div>
    <!-- 上传错误提示 -->
    <el-dialog :title="`上传失败${ reasonList.length }条`" :visible.sync="uploadFailVisible" :close-on-click-modal="false" width="640px">
      <div class="reason-container">
        <div v-for="(item, index) in reasonList" :key="index">{{ item }}</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios"
import { schoolList, userFind, province, city, userSave, editSchool, schoolAccountStatus, schoolUseDelete, adminVerify, exportSchool, getSmsState } from '@/api/api.js'
import { importAccount } from "../../api/api"

export default {
  name: 'Search',
  data: () => ({
    role: 0, // 身份 1超管 2老师 3学校

    data: [],
    phone: '',
    sms_status: '-2', //-2 全部 -1 发送失败 0 发送中 1 发送成功
    pageNum: 1,
    total: 0,
    auditNum: 0,  // 待审核数量
    isAdult: false, // 是否为审核列表

    showCreate: false,
    provinceList: [],
    cityList: [],
    createName: '',
    teacherPhone: '',
    schoolProvince: '',
    schoolCity: '',
    editId: 0,

    tableHeight: 'calc(100vh - 340px)',

    showSchoolDetail: false,
    schoolDetail: {},
    uploadFailVisible: false,
    reasonList: [], // 失败原因
    updated_at: '', // 短信状态更新时间
  }),

  async mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    if (user.role == 'admin') {
      this.role = 1
    }
    if (user.role == 'teacher') {
      this.role = 2
    }
    if (user.role == 'school') {
      this.role = 3
    }

    console.log('role', this.role)
    this.refresh()

    // 进来获取待审核数量
    let data = {
      page: 1,
      role: this.role == 3 ? 'teacher' : 'school',
      verify: 0
    }
    userFind(data).then(res=>{
      console.log('待审核', res)
      this.auditNum = res.data.data.total
    })
   
  },
  methods: {
    getFileSize(num){
      if(!num){
        return 0
      }
      if(num > 1024 * 1024 * 1024){
        return `${(num/1024/1024/1024).toFixed(2)}G`
      }
      if(num > 1024 * 1024){
        return `${(num/1024/1024).toFixed(2)}Mb`
      }
      if(num > 1024){
        return `${(num/1024).toFixed(2)}kb`
      }
      return `${num}b`
    },
    toBack() {
      if(this.isAdult){
        this.tableHeight = 'calc(100vh - 340px)'
        this.isAdult = false
        this.pageNum = 1
        this.refresh()
        let data = {
          page: 1,
          role: this.role == 3 ? 'teacher' : 'school',
          verify: 0
        }
        userFind(data).then(res=>{
          console.log('待审核', res)
          this.auditNum = res.data.data.total
        })
        return
      }
      this.$router.back()
    },
    toAdult() {
      this.tableHeight = 'calc(100vh - 300px)'
      this.isAdult = true
      this.pageNum = 1
      this.refresh()
    },
    toVerify(item,verify){
      let data = {
        id: item.id,
        verify
      }
      console.log('toVerify', data)
      adminVerify(data).then(res => {
        console.log('adminVerify', res)
        if (this.data.length == 1 && this.pageNum > 1) {
              this.pageNum = this.pageNum - 1
            }
            this.refresh()
      })
    },
    search() {
      this.pageNum = 1
      this.refresh()
    },
    pageChange(e) {
      this.pageNum = e
      this.refresh()
    },
    async refresh(){
        let data = {
            phone: this.phone,
            page: this.pageNum,
            role: this.role == 3 ? 'teacher' : 'school',
            verify: this.isAdult ? 0 : 1
        }
        if(this.sms_status > -2) {
          data.sms_status = Number(this.sms_status)
        }
        let res = null
        // if(this.role==3){
        //   res = await userFind(data)
        // } else {
        //   res = await schoolList(data)
        // }
        res = await userFind(data)
        console.log('userList', res)
        this.data = res.data.data.list
        this.total = res.data.data.total
        // userFind(data).then(res => {
        //     console.log('userFind', res)
        //     this.data = res.data.data.list
        //     this.total = res.data.data.total
        // })
        // schoolList(data).then(res => {
        //     console.log('schoolList', res)
        //     this.data = res.data.data.list
        //     this.total = res.data.data.total
        // })
    },
    toDetail(item){
      console.log('toDetail', item)
      this.schoolDetail = item
      this.showSchoolDetail = true
      getSmsState({ phone: item.phone }).then(res => {
        this.updated_at = res.data.data.updated_at
      })
    },
    closeSchoolDetail() {
      this.showSchoolDetail = false
    },
    toEdit(item) {
        this.createName = item.nick_name || item.name
        if(this.role == 1){
          this.schoolProvince = item.school.province_id
          if(this.schoolProvince){
              city({province_id: this.schoolProvince}).then(res => {
              console.log('city', res)
              this.cityList = res.data.data
          })
          }
          this.schoolCity = item.school.city_id
          this.getProvince()
        } else {
          this.teacherPhone = item.phone
        }
        this.editId = item.id
        this.showCreate = true
    },
    toBan(item) {
      console.log('toBan', item)
      let data = {
        id: item.id,
        status: item.status == 0 ? 1 : 0
      }
      schoolAccountStatus(data).then(res => {
        console.log('schoolAccountStatus', res)
        this.refresh()
      })
    },
    toDelete(item) {
      console.log('toDelete', item)
      let text = '确认删除吗?'
      if(this.role == 3){
        text = '删除老师账号后，该账号上传的资源将从平台下架，请是否确认删除？'
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log('toDelete', item)
        schoolUseDelete({ id: item.id }).then((res) => {
          console.log('deleteResource', res)
          if (this.data.length == 1 && this.pageNum > 1) {
            this.pageNum = this.pageNum - 1
          }
          this.refresh()
        })
      })
    },

    async toExport() {
      // let res = await exportSchool()
      // console.log('res', res)
      // const blob = new Blob([res.data], {
      //   type: 'application/vnd.ms-excel'
      // })
      // let url = window.URL.createObjectURL(blob)
      // let link = document.createElement('a')
      // link.style.display = 'none'
      // link.href = url
      // link.setAttribute('downLoad','学校老师注册数据')
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      this.exportExcelMethod({
        method: 'get',
        url: 'https://yey.mashu.cloud/api/school/export',
        fileName: '学校老师注册数据'
      })
    },
    exportExcelMethod(data) {
      let token = localStorage.getItem("yey-token")
      axios({
        method: data.method,
        url: `${data.url}${data.params ? '?' + data.params : ''}`,
        responseType: 'blob',
        headers: {
          // token: data.token
          Authorization: `Bearer ${token}`
        },
        timeout: 8000,
        data: data.data
      })
        .then((res) => {
          const link = document.createElement('a')
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)

          // link.download = res.headers['content-disposition'] //下载后文件名
          link.download = data.fileName //下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
        })
    },

    toAddSchool() {
      this.$router.push('/addSchool')
    },

    toCreate() {
        this.teacherPhone = ''
        this.createName = ''
        this.schoolProvince = ''
        this.schoolCity = ''
        this.cityList = []
        this.editId = 0
        this.showCreate = true
        this.getProvince()
    },
    getProvince() {
        if(this.provinceList.length == 0){
            province().then(res => {
                console.log('province', res)
                this.provinceList = res.data.data
            })
        }
    },
    selectProvince() {
        console.log('schoolProvince', this.schoolProvince)
        city({province_id: this.schoolProvince}).then(res => {
            console.log('province', res)
            this.cityList = res.data.data
            this.schoolCity = ''
        })
    },
    closeCreate() {
        this.showCreate = false
    },
    submit(){
        if(this.role == 1 && (!this.schoolProvince || !this.schoolCity)){
            this.$message.error('请先选择学校地区!')
            return
        }
        if(!this.createName){
            this.$message.error(this.role == 3 ? '请先填写老师名字!' : '请先填写学校名称!')
            return
        }
        // role: this.role == 3 ? 'teacher' : 'school'
        let data = {
            // role: 'school',
            role: this.role == 3 ? 'teacher' : 'school',
            nick_name: this.createName,
            // province_id: this.schoolProvince,
            // city_id: this.schoolCity,
            // password: '123456'
        }
        if(this.role == 3){
          let reg = /^1[3456789]\d{9}$/
          if(!reg.test(this.teacherPhone)){
            this.$message.error('请填写正确手机号!')
            return
          }
          data.phone = this.teacherPhone
        } else {
          data.province_id = this.schoolProvince
          data.city_id = this.schoolCity
        }
        if(this.editId){
            data.id = this.editId
        }
        if(!this.editId){
          data.password = '12345678'
        }
        console.log('submit', data)
        if(this.editId && this.role == 1){
          editSchool(data).then(res => {
            console.log('editSchool', res)
            this.showCreate = false
            this.refresh()
        })
        } else {
          userSave(data).then(res => {
              console.log('userSave', res)
              if(res.data.msg=='账号已存在'){
                this.$message.error('账号已存在!')
                return
              }
              this.showCreate = false
              this.refresh()
          })
        }
    },
    onBatchAddAccount(e) {
      console.log('file', e.target.files[0])
      if(e.target.files[0].name.slice(-5) != '.xlsx') {
        this.$message.error('请上传模板excel文件！')
        return
      }
      let formData = new FormData()
      formData.append('file', e.target.files[0])
      importAccount(formData).then(res => {
        console.log('上传', res)
        if(res.data.data.err.length == 0 && res.data.code == 0) {
          // 成功
          this.$message.success('上传成功！')
          
          this.refresh()
          // 进来获取待审核数量
          let data = {
            page: 1,
            role: this.role == 3 ? 'teacher' : 'school',
            verify: 0
          }
          userFind(data).then(res=>{
            console.log('待审核', res)
            this.auditNum = res.data.data.total
          })
        } else {
          // 失败
          this.reasonList = res.data.data.err
          this.uploadFailVisible = true
          // this.$alert(res.data.data.err.join('；'), '上传失败', {
          //   confirmButtonText: '确定'
          // });
        }
      })
      e.target.value = null
    },
    // 下载批量模板
    downloadTemplate() {
      window.open('https://res1.whtlkj.net/upload_file_frontend/template/yey/%E6%89%B9%E9%87%8F%E6%B7%BB%E5%8A%A0%E5%B9%BC%E5%84%BF%E5%9B%AD%E8%B4%A6%E5%8F%B7%E8%A1%A8%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx')
    }
  },
}
</script>

<style lang="less" scoped>
.pages-account {
  .yyzz{
    width: 66px;
    height: 44px;
    background: #E6E6E6;
  }
  .top-line {
    display: flex;
    height: 84px;
    width: calc(100vw - 320px);
    max-width: 1600px;
    // min-width: 1561px;
    margin: 0 auto;
    padding-left: 40px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }



  .content {
    position: relative;
    width: calc(100vw - 320px);
    max-width: 1600px;
    min-height: calc(100vh - 220px);
    // min-width: 1561px;
    margin: 0 auto;
    padding-bottom: 10px;
    background-color: #fff;
    .create-btn{
      position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 20px;
        .audit{
          position: relative;
          .audit-num{
            position: absolute;
            top: -9px;
            right: -7px;
            // width: 30px;
            min-width: 10px;
            height: 18px;
            padding: 0 4px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 18px;
            text-align: center;
            background: #FF1B1B;
            border-radius: 9px;
          }
        }
        .hide-button{
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          opacity: 0;
          cursor: pointer;
          width: 100px;
        }
    }
  }


  .create-mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(#000, 0.7);
    z-index: 9;
    .create-content{
        position: fixed;
        top: 50vh;
        left: calc(50vw - 253px);
        width: 506px;
        // height: 180px;
        padding: 40px 0 26px;
        background: #FFFFFF;
        box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.06);
        border-radius: 4px;
        box-sizing: border-box;
        transform: translateY(-50%);
        .create-close{
          position: absolute;
          top: 0;
          right: 0;
          width: 35px;
          height: 35px;
          &::before {
          content: '';
          position: absolute;
          top: 50%;
          right: 10px;
          width: 13px;
          height: 2px;
          background-color: #909399;
          border-radius: 2px;
          transform: rotate(45deg);
          }

          &::after {
          content: '';
          position: absolute;
          top: 50%;
          right: 10px;
          width: 13px;
          height: 2px;
          background-color: #909399;
          border-radius: 2px;
          transform: rotate(-45deg);
          }
        }
        .create-line{
            display: flex;
            align-items: center;
            // justify-content: center;
            height: 56px;
            padding-left: 30px;
            .create-title{
                flex-shrink: 0;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 16px;
            }
            .create-title-teacher{
              width: 180px;
              text-align: right;
            }
        }

        .submit{
            width: 77px;
            height: 28px;
            margin: 30px auto 0;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
            background: #27B2FE;
            border-radius: 100px;
            cursor: pointer;
        }
    }
  }

  .school-detail{
    position: fixed;
    top: 50vh;
    left: 50vw;
    width: 604px;
    // height: 490px;
    padding: 40px 0 26px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.06);
    border-radius: 4px;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    .school-detail-close{
      position: absolute;
      top: 0;
      right: 0;
      width: 35px;
      height: 35px;
      &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
      }

      &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
      }
    }
    .school-detail-table{
      width: 452px;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #E1E1E1;
      .school-detail-line{
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E1E1E1;
        &:last-child{
          border-bottom: none;
        }
        .school-detail-title{
          flex-shrink: 0;
          width: 112px;
          height: 12px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 16px;
          text-align: center;
          border-right: 1px solid #d8d8d8;
        }
        .school-detail-content{
          display: flex;
          align-items: center;
          min-height: 58px;
          padding: 5px 20px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          box-sizing: border-box;
        }
      }
    }
    .school-detail-ms{
      margin: 18px 76px 0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      .school-detail-ms-title{
        line-height: 24px;
        margin-bottom: 5px;
      }
      .school-detail-ms-time{
        margin-top: 16px;
        line-height: 20px;
      }
    }
    .school-detail-btn{
      margin: 30px auto 0;
      width: 140px;
      height: 42px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 42px;
      text-align: center;
      background: #27B2FE;
      border-radius: 100px;
      cursor: pointer;
    }
  }
  
  .pagination {
    position: absolute;
    bottom: 10px;
    right: 10px;
      float: right;
    }
  
  .reason-container{
    width: 600px;
    height: 400px;
    overflow-y: auto;
    line-height: 36px;
    font-size: 16px;
  }
}
</style>
